export default __webpack_public_path__ + "static/media/gallery3.05925844.JPG";